// Helper function to get team name consistently
export const getTeamName = (team: Team | UserTeamAffiliation | number | null): string => {
  if (!team) return '';
  if (typeof team === 'number') return '';
  if ('name' in team) return team.name;
  if ('team_name' in team) return team.team_name;
  return '';
};

// Helper function to get team name by ID from league data
export const getTeamNameById = (teamId: number | null | undefined, myLeague: { conferences: Array<{ divisions: Array<{ teams: Array<{ id: number; name: string }> }> }> }  | null): string => {
  if (!teamId || !myLeague?.conferences) return '';
  
  for (const conf of myLeague.conferences) {
    for (const div of conf.divisions) {
      const foundTeam = div.teams.find((t: { id: number; name: string }) => t.id === parseInt(teamId));
      if (foundTeam) {
        return foundTeam.name || '';
      }
    }
  }
  return '';
};

// Helper function to get team logo consistently
export const getTeamLogo = (team: Team | UserTeamAffiliation | number | null): string | undefined => {
  if (!team || typeof team === 'number') return undefined;
  if (typeof team === 'object' && team !== null) {
    if ('logo' in team && typeof team.logo === 'string') return team.logo;
    if ('team_logo' in team && typeof team.team_logo === 'string') return team.team_logo;
  }
  return undefined;
};

// Helper function to get team abbreviation consistently
export const getTeamAbbreviation = (team: Team | UserTeamAffiliation | number | null): string => {
  if (!team || typeof team === 'number') return '';
  if (typeof team === 'object' && team !== null) {
    if ('abbreviation' in team && typeof team.abbreviation === 'string') {
      // Extract only the letters up to the first non-whitespace character
      // e.g., "NY (AL)" becomes "NY"
      return team.abbreviation.split(/\s/)[0] || '';
    }
  }
  return '';
};


// Helper function to get team info consistently
export const getTeamInfoById = (teamId: number | null | undefined, myLeague: {  conferences: Array<{ divisions: Array<{ teams: Array<{ id: number; name: string }> }> }> } | null): Team => {
  if (!teamId || !myLeague?.conferences) return '';
  
  for (const conf of myLeague.conferences) {
    for (const div of conf.divisions) {
      const foundTeam = div.teams.find((t: { id: number; name: string }) => t.id === parseInt(teamId));
      if (foundTeam) {
        return foundTeam;
      }
    }
  }
  return { id: 0, name: '' };
};

/**
 * Find team info by abbreviation (checks rw_abbreviation and abbreviation).
 */
export const getTeamInfoByAbbreviation = (
  abbr: string | undefined,
  myLeague: { conferences?: Array<{ divisions?: Array<{ teams?: Array<any> }> }> } | null
): Team | null => {
  if (!abbr || !myLeague?.conferences) return null;
  for (const conf of myLeague.conferences) {
    for (const div of conf.divisions ?? []) {
      for (const team of div.teams ?? []) {
        const teamAbbr = team.rw_abbreviation || team.abbreviation;
        if (teamAbbr === abbr || team.abbreviation === abbr) {
          return team;
        }
      }
    }
  }
  return null;
};


// Type definitions
export interface Team {
  id: number;
  name: string;
  abbreviation?: string;
  logo?: string;
  color_primary?: string;
  color_secondary?: string;
  color_text?: string;
  prefix?: string;
}

export interface UserTeamAffiliation {
  team_name: string;
  team_logo?: string;
} 